import React from "react"

import Pwa from "react-pwa-install-ios"

export default function PwaIos(props) {
  return (
    <Pwa
      delay={0}
      force={false}
      // force={process.env.NODE_ENV === "development"}
      lang="de"
      // appIcon={tankchecker}
      appName="tankchecker.de"
    />
  )
}
